// path: src/utils/appVersion.js
// Bump APP_VERSION on each merged beta release (SemVer after Beta).

export const APP_VERSION = "Beta 1.5.6";
export const APP_FOOTER_LINE = `${APP_VERSION} · Courageous Corgis © 2026`;
